export const getMapConfig = (myStore, coords) => ({
  mapConfig: (myStore && myStore.mapCenter) || coords
})
